import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { buildApiUrl } from '@/utils/build-api-url.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors.ts';

export const useResendContributorInvitation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ contributorId, eventId }: { contributorId: string; eventId: string }) => {
      const token = await getToken();
      return resendInvitation({ contributorId, eventId }, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY],
      });
    },
  });
};

const resendInvitation = async (
  { contributorId, eventId }: { contributorId: string; eventId: string },
  token: string,
) => {
  const url = buildApiUrl(`invitations/event/${eventId}/contributors/${contributorId}/resend`);
  return sendJSONRequest({ url, method: METHOD.POST, token });
};

export default useResendContributorInvitation;
